module.exports = __webpack_public_path__ + "static/media/PH3800__006_Froggy-30sec.abed0e0f.mp3";